import { render, staticRenderFns } from "./LongCard.vue?vue&type=template&id=8c4c2d5e&scoped=true&"
import script from "./LongCard.vue?vue&type=script&lang=js&"
export * from "./LongCard.vue?vue&type=script&lang=js&"
import style0 from "./LongCard.vue?vue&type=style&index=0&id=8c4c2d5e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4c2d5e",
  null
  
)

export default component.exports